// eslint-disable-next-line import/prefer-default-export
export function randomHash() {
  return Math.random().toString(32).slice(-8);
}
